export var includesAny = function (source, targets) {
    return !!targets.find(function (target) { return source.includes(target); });
};
